import { useEffect } from "react";
import styled from "@emotion/styled/macro";
import { useTranslation } from "react-i18next";
import unknown from "../../../../assets/images/unknown.svg";
import { withProps } from "recompose";
import { Trans } from "react-i18next";
import moment from "moment";

const Wrapper = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 3em;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 1em;
    text-align: center;
    flex-direction: column;
  }
  margin: 4em 0;
  display: flex;
  box-shadow: 0px 0px 19px -11px ${({ theme }) => theme.colors.primary};
  background: ${({ theme }) => theme.colors.white};
  border: 10px solid ${({ theme }) => theme.colors.brown};
`;
const TextWrapper = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    line-height: 2.5em;
    padding: 0 2em;
  }
  line-height: 2em;
`;
const Title = styled.p`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: ${({ theme }) => theme.fontSizes.xl};
  color: ${({ theme }) => theme.colors.primary};
`;
const Subtitle = styled.p`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: 12pt;
  color: ${({ theme }) => theme.colors.secondary};
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: ${({ theme }) => theme.fontSizes.lg};
  }
`;

const LogoWrapper = styled.div`
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    align-self: center;
  }
`;
const DataWrapper = styled.div`
  line-height: 1em;
  padding: 1em 0;
`;
const BackButton = styled.button`
  border-radius: 2px;
  padding: 0.25em 1em;
  text-align: center;
  font-weight: bold;
  margin: 1em 0;
  min-width: 70%;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    min-width: auto;
  }
  border: 1px solid ${({ theme }) => theme.colors.primary};
  font-size: ${({ theme }) => theme.fontSizes.md};
  font-weight: bold;
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.primary};
  text-align: center;
`;

const InfoText = styled.p`
  font-family: ${({ theme }) => theme.fonts.body};
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme }) => theme.colors.primary};
  line-height: 1em;
  text-align: left;
`;

const Icon = withProps({ src: unknown })(styled.img`
  height: inherit;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 15em;
  }
`);

const Identification = styled.p`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: ${({ theme }) => theme.fontSizes.lg};
  color: ${({ theme }) => theme.colors.primary};
  text-align: left;
  margin-bottom: 0.5em;
`;
const Plate = styled.div`
  font-family: ${({ theme }) => theme.fonts.body};
  font-size: ${({ theme }) => theme.fontSizes.lg};
  color: ${({ theme }) => theme.colors.secondary};
  text-align: left;
`;

const Unknown = ({ info, back }) => {
  const { t } = useTranslation();
  const date = moment().format("DD-MM-YYYY");
  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  return (
    <Wrapper>
      <LogoWrapper>
        <Icon />
      </LogoWrapper>

      <TextWrapper>
        <Title>{t("insuranceCheck.unknown.title")}</Title>
        <Subtitle>{t("insuranceCheck.unknown.subtitle", { date })}</Subtitle>
        <DataWrapper>
          <Identification>
            {info.plate !== "" ? t("insuranceCheck.insured.license") : t("insuranceCheck.insured.vin")}
          </Identification>
          <Plate>{info.plate !== "" ? info.plate.toUpperCase() : info.VIN.toUpperCase()} </Plate>
        </DataWrapper>

        <InfoText>
          <Trans i18nKey="insuranceCheck.unknown.text">
            the <b> data </b>
          </Trans>
        </InfoText>
        <BackButton onClick={back}>{t("common.backSearch")}</BackButton>
      </TextWrapper>
    </Wrapper>
  );
};

export default Unknown;
